import { Reducer } from "redux";
import {
    ADD_ADDITIONAL_OUTAGE,
    REMOVE_ADDITIONAL_OUTAGE,
    SET_ADDITIONAL_OUTAGES,
    SET_AO_COUNTRY,
    SET_AO_LORT,
    SET_AO_VOLTAGE,
} from "../actions/additionalOutageActions";
import { IBranch } from "./cgmBranchesReducer";

export interface IAdditionalOutage {
    branch: IBranch;
    //timestamps: ITimestamp[];
    timestamps: number[];
}

export interface AdditionalOutageState {
    additionalOutages: IAdditionalOutage[];
    country: string;
    lort: string;
    voltage: string;
}

const initialState: AdditionalOutageState = {
    additionalOutages: [],
    country: "",
    lort: "",
    voltage: "",
};

export const additionalOutageReducer: Reducer<AdditionalOutageState> = (
    state: AdditionalOutageState = initialState,
    action: any
): AdditionalOutageState => {
    switch (action.type) {
        case SET_ADDITIONAL_OUTAGES:
            return { ...state, additionalOutages: action.aos };
        case SET_AO_COUNTRY:
            return { ...state, country: action.country };
        case SET_AO_LORT:
            return { ...state, lort: action.lort };
        case SET_AO_VOLTAGE:
            return { ...state, voltage: action.voltage };
        case ADD_ADDITIONAL_OUTAGE:
            return {
                ...state,
                additionalOutages: state.additionalOutages.concat(action.ao),
            };
        case REMOVE_ADDITIONAL_OUTAGE:
            return {
                ...state,
                additionalOutages: state.additionalOutages.filter(x => x !== action.ao),
            };
        default:
            return state;
    }
};
